export const DataTypes = Object.freeze({
  int:      'INT',
  datetime: 'DATETIME'
})
